<template>
  <v-dialog v-model="openProfileDialog" max-width="1000px" persistent>
    <div class="profile-container">
      <v-container>
        <v-row justify="space-between">
          <h1 class="profile-title">
            {{ $t('profile.title') }}
          </h1>
          <v-btn color="secondary" icon @click="closeDialog">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.name') }}:</div>
            <div class="field-value big">{{ leader.name }}</div>
          </v-col>

          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.lastname') }}:</div>
            <div class="field-value big">{{ leader.lastname }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.unity') }}:</div>
            <div class="field-value big">
              {{ getVisibleValue(leader.unities) }}
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.category') }}:</div>
            <div class="profile-rating">
              <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon class="filled">mdi-star</v-icon>
                    <v-icon
                      :class="leader.category !== 'LOCAL' ? 'filled' : ''"
                    >
                      mdi-star
                    </v-icon>
                    <v-icon
                      :class="leader.category === 'GLOBAL' ? 'filled' : ''"
                    >
                      mdi-star
                    </v-icon>
                  </span>
                </template>
                <span>{{ translateListValue(leader.category) }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.country') }}:</div>
            <div class="field-value">{{ leader.country }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.city') }}:</div>
            <div class="field-value">{{ leader.city }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('reg.id') }}:</div>
            <div class="field-value">{{ leader.idNumber }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.mobile') }}:</div>
            <div class="field-value">{{ leader.phone }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('fields.email') }}:</div>
            <div class="field-value">{{ leader.email }}</div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('reg.nativeLang') }}:</div>
            <div class="field-value">
              {{ translateListValue(leader.firstLanguage) }}
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('reg.secondLang') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.secondLanguage, true) }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('fields.profile') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.profiles, true) }}
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('reg.associations') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.cientificAs) }}
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('fields.profession') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.professions, true) }}
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('reg.postgrade') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.postGrades, true) }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('fields.specialty') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.specialties, true) }}
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('fields.subSpecialty') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.subSpecialties, true) }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('reg.expertice') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.expertices, true) }}
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('reg.courseGE') }}:</div>
            <div class="field-value">
              {{ translateListValue(leader.courseG) }}
            </div>
          </v-col>
          <v-col cols="12" md="3" v-if="isSuper">
            <div class="field-title">{{ $t('fields.endContractDate') }}:</div>
            <div class="field-value">
              {{ getDateFromString(leader.endContract) }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="field-title">{{ $t('fields.observations') }}:</div>
            <div class="field-value">
              {{ getVisibleValue(leader.observations) }}
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.createdDate') }}:</div>
            <div class="field-value small">
              {{ getDateFromTimestamp(leader.createdAt) }}
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="field-title">{{ $t('fields.updatedDate') }}:</div>
            <div class="field-value small">
              {{ getDateFromTimestamp(leader.updatedAt) }}
            </div>
          </v-col>
        </v-row>
        <v-row v-if="leader.publications && leader.publications.length">
          <v-col cols="12">
            <div class="field-title">{{ $t('reg.publications') }}:</div>
            <div class="field-value">
              <div
                v-for="(p, index) in leader.publications"
                :key="`pub-${index}`"
                class="publication-item-container"
              >
                <div class="publication-item">
                  <div>
                    <span class="bullet">&bull;</span>
                    <span class="publication-name">{{ p.name }}</span>
                  </div>
                  <div class="publication-info">
                    {{ getPublicationInfo(p) }}
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-4 mb-4"></v-divider>
        <v-row justify="center">
          <v-btn
            class="mr-4"
            color="secondary"
            @click="openCV"
            v-show="leader.cvUrl"
          >
            {{ $t('profile.seeCv') }}
          </v-btn>
          <v-btn
            class="mr-4"
            @click="editProfile"
            color="primary"
            v-if="isAdmin"
          >
            {{ $t('admin.editProfile') }}
          </v-btn>
          <v-btn class="mr-4 register-button" @click="closeDialog">
            {{ $t('common.close') }}
          </v-btn>
        </v-row>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
import _clone from 'lodash/cloneDeep'
import { mapState } from 'vuex'
import {
  getVisibleValue,
  getDateFromTimestamp,
  getDateFromString,
  getPublicationInfo,
  translateListValue
} from '@/utils/common'
import { auth } from '../firebase'
import { isUserAdmin, isUserSuper } from '@/consts/common'

export default {
  data: () => ({
    leader: {},
    isAdmin: isUserAdmin(auth.currentUser.email),
    isSuper: isUserSuper(auth.currentUser.email)
  }),
  watch: {
    selectedLeader(newVal) {
      if (newVal) {
        this.leader = _clone(newVal)
      } else {
        this.leader = {}
      }
    },
    openProfileDialog(newVal) {
      if (newVal) {
        setTimeout(() => {
          document.getElementsByClassName(
            'v-dialog v-dialog--active'
          )[0].scrollTop = 0
        }, 100)
      } else {
        this.leader = {}
      }
    }
  },

  computed: {
    ...mapState({
      openProfileDialog: state => state.leaderStore.openProfileDialog,
      registering: state => state.leaderStore.registering,
      selectedLeader: state => state.leaderStore.selectedLeader,
      leadersMap: state => state.leaderStore.leadersMap
    })
  },
  methods: {
    getDateFromTimestamp: getDateFromTimestamp,
    getVisibleValue: getVisibleValue,
    getPublicationInfo: getPublicationInfo,
    translateListValue: translateListValue,
    getDateFromString: getDateFromString,
    closeDialog() {
      this.$store.dispatch('leaderStore/openProfileDialog', false)
    },
    editProfile() {
      this.$store.dispatch('leaderStore/editLeader', {
        leader: this.leadersMap[this.selectedLeader.id]
      })
    },
    openCV() {
      this.$store.dispatch('leaderStore/openPdf', {
        url: this.leader.cvUrl,
        name: this.leader.name + ' ' + this.leader.lastname
      })
    }
  }
}
</script>
<style lang="scss">
.profile-container {
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 20px;
  word-break: break-word;

  .field-title {
    font-size: 13px;
    color: gray;
  }

  .field-value {
    font-size: 18px;
    font-weight: bold;

    &.big {
      font-size: 22px;
    }
    &.small {
      color: #8e8e8e;
      font-size: 16px;
    }
  }

  .profile-rating {
    .v-icon.v-icon {
      font-size: 32px;
      color: #c7c7c7;

      &.filled {
        color: orange;
      }
    }
  }

  .profile-title {
    text-align: left;
    color: #2e478d;
    font-size: 22px;
    padding-left: 10px;
  }

  .no-publications {
    color: #5f5f5f;
    font-size: 15px;
    text-align: center;
  }
  .bullet {
    color: #31649e;
    font-size: 24px;
    line-height: 27px;
    float: left;
  }

  .publication-name {
    font-weight: bold;
    padding-left: 2px;
  }
  .publication-info {
    color: #5d5d5d;
    font-size: 15px;
    padding-left: 10px;
  }

  .publication-item-container {
    display: flex;
    padding: 5px;
    border: 1px solid #a3b4c7;
    border-radius: 5px;
    margin-top: 5px;
    background: #eff7ff;

    .publication-item {
      width: 100%;
    }
  }
}
</style>
